export const translateSaleStatus: { [key: string]: string } = {
  0: "Cancelada",
  1: "En proceso",
  2: "Pagada",
  3: "Reembolso Pendiente",
  4: "Reembolsada",
  5: "Parcialmente Pagada",
  6: "Cuenta Abierta",
  7: "Expirada",
  8: "Por confirmar",
};

export const getTranslatedSaleStatus = (status: number): string => {
  return translateSaleStatus[status] || "Desconocido";
};

export const SALE_STATUS_KEY_TO_ID: Record<string, number> = {
  paid: 2,
  preauthorized: 1,
  parciallyPaid: 5,
  openBill: 6,
  pendingValidation: 8,
};
